module.exports = __webpack_public_path__ + "assets/img/wolf-idle.e189f9eb.png";